module.exports = __webpack_public_path__ + "img/ev-2.86e23285.svg";